/*
 * @Author: Teemo Ding
 * @Date: 2021-06-23 14:56:44
 * @LastEditors: Teemo Ding
 * @LastEditTime: 2021-06-24 10:09:14
 * @FilePath: /unifyxp-v2-store-portal/src/request/developer/index.ts
 */
import { get, post, remove } from 'src/tools/server';
export const getAccessKeys = () => {
  return get<any>(`/portal/setting/accessKeys`, {});
};
export const getAccessKeysGenerate = (title: string) => {
  return post<any>(`/portal/setting/accessKey/generate`, { title }, {});
};

export const accessKeyDownload = (keyUuid: string) => {
  return post<any>(
    `/portal/setting/accessKey/download/${keyUuid}`,
    {},
    { returnWholeData: true },
  );
};

export const accessKeyClose = (keyUuid: string) => {
  return post<any>(`/portal/setting/accessKey/close/${keyUuid}`, {}, {});
};
export const deleteAccessKeyReq = (keyUuid: string) => {
  return remove<any>(`/portal/setting/accessKey/${keyUuid}`, {});
};
